<div class="overlay-hidden" [ngStyle]="{'background-image': 'url(' + overlayImage + ')'}"
    [ngClass]="{'overlay': loadOverlay }"></div>
